<script lang="ts">
import {InforcePolicy} from "../../models/InforcePolicy";
import InforcePolicyEdit from "./InforcePolicyEdit.svelte";
import {ParseInsuranceType, updateInforcePolicy} from "../../services/ApplicationDataService";
import {createEventDispatcher} from "svelte";
export let viewInforcePolicy: InforcePolicy;
let inforcePolicy = {...viewInforcePolicy};
let editMode: Boolean = false;
let inforceForm;
const dispatch = createEventDispatcher();
let buttonText = 'Edit my information';
const toggleInforcePolicyEditMode = () => {
   if (editMode) {
       if (!inforceForm.checkValidity()) {
           return false;
       }
       buttonText = 'Edit my information';
      updateInforcePolicy(inforcePolicy);
      inforcePolicy = {...inforcePolicy};
   } else {
      buttonText = 'Close and save my information'
   }
    editMode = !editMode
   dispatch("modeOnChange", editMode);
}

$: if (viewInforcePolicy) {
    inforcePolicy = {...viewInforcePolicy};
}


</script>

<form bind:this={inforceForm} >
<div class="insured-details info-section">
    <div class="edit-section">
       <h2>Inforce Policy</h2>
    </div>
 <hr/>

    {#if !editMode}
        <div class="text-section">
            <div class="text-row">
                <div class="text-group">
                    <div class="content-text-label">Company Name:</div>
                    <div class="bold-text">{inforcePolicy.companyName || ''} </div>
                </div>
            </div>
            <div class="text-row">
                <div class="text-group">
                    <div class="content-text-label">Year Issued:</div>
                        <div class="bold-text">{inforcePolicy.yearIssued || ''} </div>
                </div>
            </div>

            <div class="text-row">
                <div class="text-group">
                    <div class="content-text-label">Face Amount:</div>
                    <div class="bold-text">{inforcePolicy.faceAmount || ''}</div>
                </div>
            </div>
<!-- Change ToBEREplaced to yes/no flag -->
            <div class="text-row">
                <div class="text-group">
                    <div class="content-text-label">Replacing:</div>
                    <div class="bold-text">{inforcePolicy.toBeReplaced === true ? 'Yes' : inforcePolicy.toBeReplaced === false ? 'No': '' || ''}</div>
                </div>
            </div>
            <div class="text-row">
                <div class="text-group">
                    <div class="content-text-label">Policy Number:</div>
                    <div class="bold-text">{inforcePolicy.policyNumber || ''}</div>
                </div>
            </div>
            <div class="text-row">
                <div class="text-group">
                    <div class="content-text-label">Insurance Type:</div>
                    <div class="bold-text">{ParseInsuranceType(inforcePolicy.insuranceType) || ''}</div>
                </div>
            </div>
        </div>
    {/if}

    {#if editMode}
        <InforcePolicyEdit inforcePolicy={inforcePolicy} />
    {/if}
    <div> <button on:click={toggleInforcePolicyEditMode} class="card-link buttonWithoutBorder" type="button">{buttonText}</button></div>
</div>
</form>
<style lang="scss">
  @use "../../../component_scss_library/layout" as layout;
  @use "../../../component_scss_library/buttons" as buttons;


</style>
